import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { preloadImage } from './utils/lazyLoad'

// Preload critical hero images for better LCP
preloadImage('https://static.lumi.new/04/046f4471a0fc4fe3f17496cfbb9a6ed4.jpeg', 'high');
preloadImage('https://static.lumi.new/6d/6d4d1abfe846004705cd88034d1a4139.jpeg', 'high');

createRoot(document.getElementById('root')!).render(
  <App />,
)
